import * as React from "react"
import {TabsSeeker} from "@ui-seeker/core";

import { DISPLAY_TABS } from "./@constants";


const TABS = [
	{label: 'Top 20 Higher Dispersions', value: DISPLAY_TABS.TOP_HIGHER},
	{label: 'Top 20 Lower Dispersions', value: DISPLAY_TABS.TOP_LOWER}
]

export default function PriceTopMarketDispersionTabs({ value, onChange }) {
    return <TabsSeeker
		tabs={TABS}
		value={value}
		onChange={onChange}
	/>
}